
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { filter, Observable, of, tap } from 'rxjs';
import { MotButtonComponent } from 'src/app/@forms/components/mot-button/mot-button.component';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { CookiesService } from 'src/app/@shared/services/cookies/cookies.service';
import { Language, LanguageService } from 'src/app/@shared/services/language/language.service';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { DATA_INJECTION_TOKEN } from 'src/app/@shared/services/overlay/overlay.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { CHNAGES_OPTIONS, eChangesOptions } from 'src/app/modules/route-planner/constants/changes-options.constants';
import { ACCESSIBILLITY, APPLY_AND_SAVE_AS_DEFAULTS, APPLY_FILTERS, BUS, CARMELIT, CHANGES, CLEAR_FILTERS, FASTEST_ROUTE_SORT, FILTERING_AND_SORTING, FREQUENCY_AND_TRAVEL_TIME_SORT, LEAST_CHANGES_SORT, LEAST_WALKING_TIME_SORT, LIGHT_TRAIN, MAX_TRAVEL_TIME, MAX_WALKING_TIME, PUBLIC_TAXI, RAHBALIT, SHOW_ACCESSIBLE_TRANSPORT, SORT_BY, TRAIN, TRANSPORT_METHODS, WITH_CHANGES, WITHOUT_CHANGES } from 'src/app/modules/route-planner/constants/multi-language.constants';
import {
  SORT_OPTIONS,
  eSortOptions,
} from 'src/app/modules/route-planner/constants/sort-options.constants';
import {
  TRANSPORTATION_OPTIONS,
  eTransportationOptions,
} from 'src/app/modules/route-planner/constants/transportation-options.constants';
import { SourceDestinationFiltersForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/filters/source-destination-filters-form';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { FilterStateService } from 'src/app/modules/route-planner/services/filters/filter-state.service';
import { Direction } from '@angular/cdk/bidi';

@Component({
    selector: 'app-route-filters',
    templateUrl: './route-filters.component.html',
    styleUrls: ['./route-filters.component.scss'],
    standalone: false
})
export class RouteFiltersComponent
  extends CardDesignComponent
  implements OnInit {
  maxTravelTimeValue: number = 600
  maxWalkingTimeValue: number = 120


  private _defaultFilters: SourceDestinationFiltersForm = {
    isAccessible: false,
    transportations: [eTransportationOptions.BUS, eTransportationOptions.CARMELIT, eTransportationOptions.LIGHT_TRAIN, eTransportationOptions.PUBLIC_TAXI, eTransportationOptions.RAHBALIT, eTransportationOptions.TRAIN],
    changes: true,
    sortBy: eSortOptions.FREQUENCY_AND_TRAVEL_TIME,
    maxTravelTime: this.maxTravelTimeValue,
    maxWalkTime: this.maxWalkingTimeValue,
  };

  private _userSavedFilters: SourceDestinationFiltersForm;

  filtersForm: FormGroup;

  transportationOptions$: Observable<SelectOption<eTransportationOptions>[]> =
    of(TRANSPORTATION_OPTIONS).pipe(
      tap((options) => {
        // const transportationCtrl = this.filtersForm.controls['transportations'];
        // const transportationValues = options.map((opt) => opt.value);

        // if (!!transportationCtrl && !this.filtersForm.dirty) {
        //   this.filtersForm.controls['transportations'].patchValue(
        //     transportationValues
        //   );
        // }

        // this._defaultFilters.transportations = transportationValues;
      })
    );

  sortOptions: Observable<SelectOption<eSortOptions>[]>;
  changesOptions: Observable<SelectOption<boolean>[]>;

  filteringAndSortingText: string
  sortByText: string
  clearFiltersText: string
  transportMethodsText: string
  accessibllityText: string
  showAccessibleTransportText: string
  changesText: string
  maxTravelTimeText: string
  maxWalkingTimeText: string
  applyFiltersText: string
  applyAndSaveText: string

  direction: Direction

  arrowIconName: string


  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,

    @Inject(DATA_INJECTION_TOKEN)
    public data: { initialFilters: SourceDestinationFiltersForm },

    private readonly fb: FormBuilder,
    private readonly localStorageService: LocalStorageService,
    private readonly languageService: LanguageService,
    private readonly utilService: UtilsService,
    private readonly cookiesService: CookiesService,
    private readonly modalService: ModalService,
    private readonly filterStateService: FilterStateService,
    private readonly cdr: ChangeDetectorRef
  ) {
    super(routePlanningService, resizeService);

    this.filtersForm = fb.group({
      isAccessible: new FormControl<boolean>(this._defaultFilters.isAccessible),
      transportations: new FormControl<eTransportationOptions[]>(
        this._defaultFilters.transportations
      ),
      sortBy: new FormControl<eSortOptions>(
        this._defaultFilters.sortBy
      ),
      maxTravelTime: new FormControl<number>(
        this._defaultFilters.maxTravelTime
      ),
      maxWalkTime: new FormControl<number>(this._defaultFilters.maxWalkTime),
      changes: new FormControl<boolean>(true)
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Get SAVED filters from localStorage (not current in-memory filters)
    const savedFilters: SourceDestinationFiltersForm =
      this.filterStateService.getUserSavedFilters();

    // Set _userSavedFilters ONLY from localStorage (saved filters)
    if (!!savedFilters) {
      this._userSavedFilters = savedFilters;
    }
    
    // Use initialFilters (current applied filters) for form display
    if (this.data && this.data.initialFilters) {
      // Merge defaults with the supplied initial filters to ensure all properties (like isAccessible) are present
      const mergedFilters = { ...this._defaultFilters, ...this.data.initialFilters };
      this.filtersForm.patchValue(mergedFilters);
    } else if (!!savedFilters) {
      // If no initialFilters, use saved filters
      this.filtersForm.patchValue(savedFilters);
    }
    
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      if(this.direction) {
        this.closeCard({reOpen: true});
        return;
      }
      this.direction = language.direction
      this.filteringAndSortingText = FILTERING_AND_SORTING[language.language]
      this.sortByText = SORT_BY[language.language]
      this.clearFiltersText = CLEAR_FILTERS[language.language]
      this.transportMethodsText = TRANSPORT_METHODS[language.language]
      this.accessibllityText = ACCESSIBILLITY[language.language]
      this.showAccessibleTransportText = SHOW_ACCESSIBLE_TRANSPORT[language.language]
      this.changesText = CHANGES[language.language]
      this.maxTravelTimeText = MAX_TRAVEL_TIME[language.language]
      this.maxWalkingTimeText = MAX_WALKING_TIME[language.language]
      this.applyFiltersText = APPLY_FILTERS[language.language]
      this.applyAndSaveText = APPLY_AND_SAVE_AS_DEFAULTS[language.language]

      this.arrowIconName = language.direction === "rtl" ? "chevron-right" : "chevron-left"

      this.setSortOptionsByLanguage(language)
      this.setChangesOptionsByLanguage(language)
      this.setTransportOptionsByLanguage(language)
    })
  }

  setSortOptionsByLanguage(language: Language) {
    const sortOptArray = [...SORT_OPTIONS]
    sortOptArray.forEach(sortOpt => {
      switch (sortOpt.value) {
        case eSortOptions.FREQUENCY_AND_TRAVEL_TIME:
          sortOpt.label = FREQUENCY_AND_TRAVEL_TIME_SORT[language.language]
          break
        case eSortOptions.SHORTEST_TIME:
          sortOpt.label = FASTEST_ROUTE_SORT[language.language]
          break
        case eSortOptions.FEWEST_WALK_TIME:
          sortOpt.label = LEAST_WALKING_TIME_SORT[language.language]
          break
        case eSortOptions.FEWEST_STATION_SWITCH:
          sortOpt.label = LEAST_CHANGES_SORT[language.language]
          break
      }
    })
    this.sortOptions = of(sortOptArray)
  }

  setChangesOptionsByLanguage(language: Language) {
    const changesOptArray = [...CHNAGES_OPTIONS]
    changesOptArray.forEach(changeOpt => {
      switch (changeOpt.label) {
        case WITHOUT_CHANGES.hebrew:
        case WITHOUT_CHANGES.english:
        case WITHOUT_CHANGES.arabic:
          changeOpt.label = WITHOUT_CHANGES[language.language]
          break
        case WITH_CHANGES.hebrew:
        case WITH_CHANGES.english:
        case WITH_CHANGES.arabic:
          changeOpt.label = WITH_CHANGES[language.language]
          break
      }
    })
    this.changesOptions = of(changesOptArray)
  }

  setTransportOptionsByLanguage(language: Language) {
    const transportOptArray = [...TRANSPORTATION_OPTIONS]
    transportOptArray.forEach(transportOpt => {
      switch (transportOpt.value) {
        case eTransportationOptions.BUS:
          transportOpt.label = this.utilService.convertFirstLatterCapital(BUS[language.language])
          break
        case eTransportationOptions.TRAIN:
          transportOpt.label = this.utilService.convertFirstLatterCapital(TRAIN[language.language])
          break
        case eTransportationOptions.LIGHT_TRAIN:
          transportOpt.label = this.utilService.convertFirstLatterCapital(LIGHT_TRAIN[language.language])
          break
        case eTransportationOptions.CARMELIT:
          transportOpt.label = this.utilService.convertFirstLatterCapital(CARMELIT[language.language])
          break
        case eTransportationOptions.RAHBALIT:
          transportOpt.label = this.utilService.convertFirstLatterCapital(RAHBALIT[language.language])
          break
        case eTransportationOptions.PUBLIC_TAXI:
          transportOpt.label = this.utilService.convertFirstLatterCapital(PUBLIC_TAXI[language.language])
          break
      }
    })

    this.transportationOptions$ = of(transportOptArray).pipe(
      tap((options) => {
        const transportationCtrl = this.filtersForm.controls['transportations'];
        const transportationValues = options.map((opt) => opt.value);

        if (!!transportationCtrl && !this.filtersForm.dirty && !this.data.initialFilters) {
          this.filtersForm.controls['transportations'].patchValue(
            transportationValues
          )
        }

        this._defaultFilters.transportations = transportationValues;
      })
    );
  }

  applyFilters(saveFilters?: boolean) {
    const filterFormValues: SourceDestinationFiltersForm = this.filtersForm.value;

    const isDefaultFilters = this.filtersAreEqual(this._defaultFilters, filterFormValues)

    if (saveFilters) {
      // Persist filters to localStorage only if cookie consent is granted.
      this.cookiesService.consentGranted$.subscribe((consent) => {
        if (consent) {
          this.filterStateService.setFilters(filterFormValues);
          // Update user saved filters so resetFilters() uses the new saved values
          this._userSavedFilters = filterFormValues;
          this.closeCard({
            value: filterFormValues,
            applyFilters: true, // Always apply when user clicks apply button
            isDefaultFilters
          });
        }
      });
    } else {
      // Only update in-memory filter state without saving to localStorage.
      this.filterStateService.setFiltersTransient(filterFormValues);
      this.closeCard({
        value: filterFormValues,
        applyFilters: true, // Always apply when user clicks apply button
        isDefaultFilters,
      });
    }
  }

  resetFilters() {
    // Reset to user saved filters if they exist, otherwise to default filters
    const filtersToReset = this._userSavedFilters ?? this._defaultFilters;
    
    // Manually update each control to ensure change detection triggers
    Object.keys(filtersToReset).forEach(key => {
      const control = this.filtersForm.get(key);
      if (control) {
        control.setValue(filtersToReset[key], { emitEvent: true });
        control.updateValueAndValidity({ emitEvent: true });
      }
    });
    
    this.filtersForm.markAsPristine();
    this.filtersForm.markAsUntouched();
    
    this.cdr.detectChanges();
  }

  private filtersAreEqual(
    originalFilters: SourceDestinationFiltersForm,
    newFilters: SourceDestinationFiltersForm
  ): boolean {
    return (
      Object.keys(newFilters).find((filterKey) => {
        const originalValue = originalFilters[filterKey];
        const newValue = newFilters[filterKey];

        if (Array.isArray(originalValue) && Array.isArray(newValue)) {
          const originalSorted = [...originalValue].sort();
          const newSorted = [...newValue].sort();
          return !originalSorted.every((val, index) => val === newSorted[index]);
        } else {
          return originalValue !== newValue;
        }
      }) == null
    );
  }

  getFormControl(formControlName: string): FormControl {
    return this.filtersForm.get(formControlName) as FormControl;
  }

  onHeaderClose() {
    // Return current form values when closing without applying
    // This ensures that if filters were reset, the reset values are returned
    this.closeCard({ 
      value: this.filtersForm.value, 
      applyFilters: false 
    });
  }

  override handleOverlayEscape(): void {
    this.onHeaderClose();
  }

}
